module.exports = __webpack_public_path__ + "static/free_float-977e8a39bf8905202f4fb0fb7fb006e7.png";